import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles';
import { ChoiceButton } from 'react-design-components';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 340,
      minHeight: 135,
      [theme.breakpoints.down('xs')]: {
        maxWidth: 155,
        minHeight: 94,
      },
    },
  }),
);

interface Props {
  onClick: (e: any) => void;
  children: React.ReactNode;
}

const CheckChoiceButton: React.FC<Props> = ({ onClick, children }: any) => {
  const classes = useStyles();

  return (
    <ChoiceButton className={classes.root} onClick={onClick}>
      {children}
    </ChoiceButton>
  );
};

export default CheckChoiceButton as React.ComponentType<Props>;
